import type {EnableInMeetingUIAutoHideState} from '@pexip/media-components';
import {createSignal} from '@pexip/signal';

export const enableInMeetingUIAutoHide =
    createSignal<EnableInMeetingUIAutoHideState>({
        name: 'meeting:ui:auto-hide',
        allowEmittingWithoutObserver: true,
    });
